<template>
  <div class="news page">
    <van-row class="padding10 h-header" style="background: #fff">
      <van-col span="12">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/logo_black.png" style="width:60%;">
      </van-col>
      <van-col span="12" class="text-right" @click="navShow">
        <span style="color: grey;">菜单</span> <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/menu_grey.png" style="width:10%">
      </van-col>
    </van-row>
    <!--      顶部图片部分-->
    <van-row style="margin-top:40px">
      <van-col span="24">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/page/banner.png" style="width:96%;margin-left:2%;margin-bottom:7px;margin-top:10px;" @click="$goToUrl('/join')">
      </van-col>
    </van-row>
<!--    正文部分-->
    <van-row class="pageCenter">
      <van-col span="24" class="pageTitle">
        {{this.newsDetail.title}}
      </van-col>
      <van-col span="24" class="pageTime">
        {{newsDetail.creatTime}}
      </van-col>
      <van-col span="24" class="pageContent margin-top-10" style="width:100%;" v-html="newsDetail.content">
        {{newsDetail.content}}
        <!-- <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/page/page1.jpg" class="width100">
        <span>
          临近年底，疫情却卷土重来，为了降低疫情传染风险，保障居民安全，各地相继发出倡议，鼓励人们“就地过年”减少出行。同城即时递送平台365跑腿网在全国拥有100多万名注册骑手，春节期间，他们也将留守在就业地，为满足市民日常生活所需贡献自己的一份力量。2月4日，365跑腿网开始为骑士免费发放年货，作为“春节留守助力行动”的一部分，365跑腿网希望能够给留守的骑士提供一些生活上的帮助，让他们能够在留守地过一个祥和温馨的春节。
        </span>
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/page/page2.png" class="width100">
        <span>
           “本次给骑手送过年礼包也是我们春节留守助力行动的一部分。”365跑腿网总裁胡旭亮介绍，“365跑腿网已在全国范围内启动‘春节留守助力行动’，帮助就地过年人员可以通过临时加入骑手队伍增加收入，365跑腿网会通过现金红包、转盘抽奖、接单奖励等举措发放超过千万元奖励。另外，我们也希望能够提供一些特色年货，让骑手感受到异地过年的温暖。”
        </span> -->
      </van-col>
    </van-row>
<!--    上下页-->
    <!-- <van-row type="flex">
      <van-col class="pageSize" span="10" offset="4">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/page/left.png" alt=""><span>上一篇</span>
      </van-col>
      <van-col class="pageSize" span="10">
        <span>下一篇</span><img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/page/right.png" alt="1">
      </van-col>
    </van-row> -->
<!--    相关推荐-->
    <van-row class="pageCenter" style="width:100%;">
      <van-col span="24">
        <span class="float-left text-df" style="margin-left:10px;">
        相关推荐
      </span>
        <span class="float-right text-xs" style="margin-right: 10px" @click="$goToUrl('/news')">
        查看更多 >
      </span>
      </van-col>
      <van-col>
        <ul class="newsBlock">
          <div v-for="(item, index) in newsList" :key="index">
            <li @click="goDetails(item)" v-if="item.type=='0'">
              <img :alt="item.title" :src="item.thumb">
              <div class="newsBlockRight">
                <span class="newsBlockTitle">{{item.title}}</span>
                <span class="newsBlockDesc">{{item.desc}}</span>
              </div>
            </li>
          </div>
          <!-- <li>
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/news/news_image.png" alt="">
            <div class="newsBlockRight">
              <span class="newsBlockTitle">365为就地过年骑手发年货</span>
              <span class="newsBlockDesc">2月4日，365跑腿网开始为骑手免费发放年 货，作为“春节留守助力行动”的一部分……</span>
            </div>
          </li>
          <li>
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/news/news_image.png" alt="">
            <div class="newsBlockRight">
              <span class="newsBlockTitle">365为就地过年骑手发年货</span>
              <span class="newsBlockDesc">2月4日，365跑腿网开始为骑手免费发放年 货，作为“春节留守助力行动”的一部分……</span>
            </div>
          </li>
          <li>
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/news/news_image.png" alt="">
            <div class="newsBlockRight">
              <span class="newsBlockTitle">365为就地过年骑手发年货</span>
              <span class="newsBlockDesc">2月4日，365跑腿网开始为骑手免费发放年 货，作为“春节留守助力行动”的一部分……</span>
            </div>
          </li> -->
        </ul>
      </van-col>
    </van-row>
<!--    底部banner部分-->
    <van-row>
      <van-col span="24">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/news/banner.png" style="width:96%;margin-left:2%;margin-bottom:7px;margin-top:10px;">
      </van-col>
    </van-row>
<!--    底部-->
    <van-row class="riderFooter">
      <van-col span="24">
        <ul class="foot-nav text-df-">
          <li>首页</li>
          <li>城市合作</li>
          <li>365头条</li>
          <li>品牌实力</li>
          <li>骑士之家</li>
        </ul>
      </van-col>
      <van-col span="24" class="text-df- margin-top-20" style="color:#E7E7E7;" @click="this.$goToUserClient">
        客户端下载
      </van-col>
      <van-col>
        <ul class="footBtnGroup">
          <li @click="this.$goToUserClient">
            <span>客户、商家端APP下载</span>
          </li>
          <li @click="this.$goToDriverClient">
            <span>骑士端APP下载</span>
          </li>
        </ul>
      </van-col>
      <van-col span="24" class="footInfo" style="margin-top:50px;">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/logo.png" style="height:20px;">
      </van-col>
      <van-col span="24" class="footInfo">
        客服热线：17669726588
      </van-col>
      <van-col span="24" class="footInfo">
        ©2014-2021 青岛众业网络科技有限公司
      </van-col>
      <van-col span="24" class="footInfo">
        备案号：辽B2-20150082
      </van-col>
    </van-row>
    <!--        导航弹出层-->
    <van-popup v-model="navModal" position="right" :style="{ width: '100%',height:'100%' }">
      <navModal @closeNavModal="closeNavModal"></navModal>
    </van-popup>
  </div>
</template>

<script>
  import navModal from '../components/common/nav';
  import axios from 'axios'
  export default {
    name: '',
    data () {
      return {
        navModal:false,
        swiperOption: {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        id: '',
        newsDetail:{},
        newsList:[]
      }
    },
    components:{navModal},
    created(){
      this.getNews()
      console.log(this.$route.query.id,'this.$route.query.id')
      this.id = this.$route.query.id;
      this.getDetail(this.id)
    },
    methods:{
      // 导航展示
      navShow(){
        this.navModal = true;
      },
      // 关闭导航模块
      closeNavModal(){
        this.navModal = false;
      },
      getDetail(id){
        axios.get('https://qd365oss.oss-cn-beijing.aliyuncs.com/web/json/news/content/'+id+'.json').then((res)=>{ 
          if(res.data.errorcode == '100'){
            this.newsDetail = res.data.data;
          }
        })
      },
      getNews(){
        axios.get('https://qd365oss.oss-cn-beijing.aliyuncs.com/web/json/news/list.json').then((res)=>{ 
          this.newsList = res.data
         })
      }
    }
  }
</script>
<style lang="less">
  .page{
    background: #f7f7f7;
    .pageCenter{width:96%;margin-left:2%;}
    .pageTitle{font-size:1.4em;}
    .pageTime{font-size:0.9em;color:#A0A0A0;border-bottom:1px solid #e2e2e2;padding:10px 0;letter-spacing: 1px;font-weight: 200}
    .pageContent{
      color:#646464;
      font-weight: 300;
      line-height: 27px;
      *{
        width: 100%;
      }
    }
    .pageSize{
      margin-top:10px;
      margin-bottom:10px;
      *{vertical-align: middle}
      img{height:12px;margin:0 20px}
    }
    .newsBlock li{border:1px solid #CCC;padding:7px;width:calc(100% - 14px);box-shadow: 2px 1px 10px #ddd;}
  }
</style>
